import clsx from 'clsx';
import { memo } from 'react';

import type { SideNavLink } from '../types';

import { StatusBadge } from '../../../../StatusBadge/StatusBadge';
import { useSideNavContext } from '../context';
import { isLinkCurrent } from '../utils';
import { SideNavControl } from './SideNavControl';
import { SideNavPinButton } from './SideNavPinButton';

interface SideNavSubItemProps {
  link: SideNavLink;
}

export const SideNavSubItem = memo(function SideNavSubItem({
  link,
}: SideNavSubItemProps) {
  const { activeKey, labels, onActivate, pinControl, regionAttributes } =
    useSideNavContext();
  const isCurrent = isLinkCurrent(link.key, activeKey);
  const isPinned = pinControl?.isPinned(link.key) ?? false;

  return (
    <div
      className={clsx(
        'eds-side-nav--sub-item',
        isCurrent && 'eds-side-nav--sub-item--active',
      )}
    >
      <SideNavControl
        className="eds-side-nav--sub-item-control"
        isCurrent={isCurrent}
        link={link}
        onActivate={onActivate}
      >
        <span className="eds-side-nav--sub-item-label">{link.label}</span>
        {link.badge && (
          <span className="eds-side-nav--item-badge">
            <StatusBadge status="informational" text={link.badge} />
          </span>
        )}
      </SideNavControl>
      {pinControl && (
        <SideNavPinButton
          dataAttributes={
            isPinned ? regionAttributes.unpin : regionAttributes.pin
          }
          isPinned={isPinned}
          label={isPinned ? labels.unpin(link.label) : labels.pin(link.label)}
          onToggle={() => pinControl.onToggle(link.key)}
        />
      )}
    </div>
  );
});
